"use client";

import type Country from "@interfaces/Country";
import { countries } from "@lib/constants/countries";
import { useLocale } from "next-intl";

type UseCountrySelector = () => [Country[], string];

export const useCountriesSelector: UseCountrySelector = () => {
    const locale = useLocale();
    const countriesSorted = countries.sort((a, b) => a.name.localeCompare(b.name));

    return [countriesSorted, locale];
};
